import { useT } from '../../i18n/LocaleContext'
import { Field, Select } from './fields'
import { PLATFORMS, type DevisAnswers, type Platform } from './types'

export default function StepContact({
  answers,
  update,
}: {
  answers: DevisAnswers
  update: (patch: Partial<DevisAnswers>) => void
}) {
  const { t } = useT()
  const platformOptions = PLATFORMS.map((p) => ({ value: p, label: t('devisWizard.platforms.' + p) }))

  return (
    <div className="space-y-5">
      <h3 className="text-lg font-semibold tracking-tight text-ink-950">{t('devisWizard.step3.title')}</h3>

      <div className="grid gap-5 sm:grid-cols-2">
        <Field
          label={t('devisWizard.step3.nameLabel')}
          name="name"
          required
          placeholder={t('devisWizard.step3.namePh')}
          value={answers.name}
          onChange={(v) => update({ name: v })}
        />
        <Field
          label={t('devisWizard.step3.emailLabel')}
          name="email"
          type="email"
          required
          placeholder={t('devisWizard.step3.emailPh')}
          value={answers.email}
          onChange={(v) => update({ email: v })}
        />
      </div>

      <div className="grid gap-5 sm:grid-cols-2">
        <Field
          label={t('devisWizard.step3.phoneLabel')}
          name="phone"
          type="tel"
          required
          placeholder={t('devisWizard.step3.phonePh')}
          value={answers.phone}
          onChange={(v) => update({ phone: v })}
        />
        <Field
          label={t('devisWizard.step3.websiteLabel')}
          name="website"
          type="url"
          placeholder={t('devisWizard.step3.websitePh')}
          value={answers.website}
          onChange={(v) => update({ website: v })}
        />
      </div>

      <Select
        label={t('devisWizard.step3.platformLabel')}
        name="platform"
        options={platformOptions}
        placeholder={t('devisWizard.step3.platformPh')}
        value={answers.platform}
        onChange={(v) => update({ platform: v as Platform })}
      />

      <p className="text-[11px] leading-relaxed text-ink-500">{t('devisWizard.step3.privacy')}</p>
    </div>
  )
}
